/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import {
  Box, Grid, makeStyles, LinearProgress,
} from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  React, useEffect, useState,
} from 'react';
import { useProject } from '../../config/ProjectContext';
import GraphqlService from '../../service/graphqlService';
import PageBanner from '../../components/utils/PageBanner';
import SimpleAlert from '../../components/utils/SimpleAlert';
import FiltersWithMultiSelect from '../../components/utils/FiltersWithMultiSelect';
import { validate, calculateEndDateTimeIso, calculateStartDateTimeIso } from '../../utils/dateUtils';
import DeviceRawDataTable from './MachineTelemetry/DeviceRawDataTable';
import useAnalytics from '../../hooks/useAnalytics';
// import FineGrainedPermissionsInfo from '../Admin/FineGrainedPermissions/FineGrainedPermissionsInfo';
// import useIsDevicePermissionAllowed from '../../hooks/useIsDevicePermissionAllowed';

const useStyles = makeStyles((theme) => ({
  formField: {
    width: '100%',
    '& ::placeholder': {
      paddingLeft: 8,
      paddingTop: 8,
    },
  },
  formPlaceholder: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: 'blue',
    },
  },
  inputDescriptionLabel: {
    font: theme.typography.h4.font,
    fontSize: 16,
    color: theme.palette.primary.text,
    paddingTop: 24,
    paddingLeft: 24,
    backgroundColor: theme.palette.background.form,
  },
  contentInfo: {
    paddingTop: 24,
    paddingBottom: 8,
    paddingLeft: 24,
    paddingRight: 24,
    backgroundColor: theme.palette.background.default,
  },
  // tabs
  headerTabPanel: {
    backgroundColor: theme.palette.background.paper,
  },
  labelHeaderTabPanel: {
    color: theme.palette.primary.labelHeader,
    fontFamily: theme.typography.h3.fontFamily,
    fontSize: '14px',
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0',
    lineHeight: '16px',
    textAlign: 'center',
    width: '720px',
    height: '48px',
  },
  detailsTitle: {
    paddingRight: '5px',
    fontFamily: theme.typography.h5.fontFamily,
    lineHeight: theme.typography.h5.lineHeight,
    letterSpacing: theme.typography.h5.letterSpacing,
    fontSize: theme.typography.h5.fontSize,
    color: theme.palette.primary.subMain,
  },
  accordion: {
    borderRadius: '12px !important',
  },
  details: {
    paddingLeft: 24,
    paddingRight: 24,
  },
}));

export default function DeviceRawData({ deviceSerial, shouldClear, onClearComplete }) {
  const MAX_DAYS_BETWEEN_DATES = 90;

  // STATE________________________________
  const { project } = useProject();
  const { setAnalytics } = useAnalytics();

  // grid
  const [reducedPage, setReducedPage] = useState(0);
  const [paginationTokens, setPaginationTokens] = useState(['']);
  const [rowsPerPageConsumption] = useState(100);
  const [reducedResponse, setReducedResponse] = useState(null);

  //  alert data
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertHeader, setAlertHeader] = useState('');
  const [alertText, setAlertText] = useState('');

  //  state values
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  // errors
  const [dateStartError, setDateStartError] = useState(false);
  const [dateEndError, setDateEndError] = useState(false);
  const [greaterSmallerDateError, setGreaterSmallerDateError] = useState(false);
  const [moreThanMaxDaysDateError, setMoreThanMaxDaysDateError] = useState(false);
  const [deviceSerialError, setDeviceSerialError] = useState(false);

  // data
  const [selectedFilters, setSelectedFilters] = useState('');
  const [validity, setValidity] = useState('valid');
  const [selectedStartDate, setSelectedStartDate] = useState(moment().add(-7, 'days'));
  const [selectedStartTime, setSelectedStartTime] = useState(moment().add(-7, 'days').format('HH:mm'));
  const [selectedEndDate, setSelectedEndDate] = useState(moment());
  const [selectedEndTime, setSelectedEndTime] = useState(moment().format('23:59'));
  const [dateRangePickerVisibility, setDateRangePickerVisibility] = useState(true);
  // progress dialog
  const [isLoading, setIsLoading] = useState(false);

  // params
  const [params, setParams] = useState({ deviceSerial, messageType: '', messageDirection: '' }); // Initialize messageDirection

  // const { isAllowed: isDeviceAllowed, isLoading: isLoadingDevicePermission, isFetching: isFetchingDevicePermission } = useIsDevicePermissionAllowed(params.deviceSerial);

  const onChangeDeviceSerial = (newValue) => {
    setDeviceSerialError(false);
    const trimmedValue = typeof newValue === 'string' ? newValue.trim() : newValue;
    setParams({ ...params, deviceSerial: trimmedValue });
  };

  const onChangeMessageTypes = (newValue) => {
    setParams({ ...params, messageType: newValue }); // newValue is already a string
  };

  const onChangeMessageDirection = (newValue) => {
    setParams({ ...params, messageDirection: newValue });
  };

  function openAlert(header, text) {
    setAlertHeader(header);
    setAlertText(text);
    setAlertOpen(true);
  }

  // functions to obtain the data to show
  async function searchObject(myProject, filters, startDate, endDate, paginationToken, validityValue) {
    // console.log('[DeviceRawData] searchObject: Checking permissions with deviceSerial:', params.deviceSerial,
    //   '| isDeviceAllowed:', isDeviceAllowed,
    //   '| isLoadingPermission:', isLoadingDevicePermission,
    //   '| isFetchingPermission:', isFetchingDevicePermission);

    // if (isLoadingDevicePermission || isFetchingDevicePermission) {
    //   // Permissions are still loading, so don't proceed and don't show a permissions error.
    //   console.log('[DeviceRawData] searchObject: Permissions are loading. Aborting search.');
    //   return null;
    // }
    // if (!isDeviceAllowed) {
    //   console.log('[DeviceRawData] searchObject: Permission denied. Aborting search.');
    //   openAlert('Error', 'Device does not have the required permissions.');
    //   return null;
    // }
    setDateRangePickerVisibility(!dateRangePickerVisibility);

    // Build query parameters based on selected filters
    const queryParams = {};

    // Add deviceSerial if it's not empty
    if (params.deviceSerial !== '') {
      queryParams.deviceSerial = params.deviceSerial;
    }

    // Add messageTypes if there are any selected
    if (params.messageType && params.messageType.length > 0) {
      // Backend expects an array of numbers, or a comma separated string that it can parse.
      // If backend expects array of numbers, split the string. Otherwise, send as is.
      // Assuming backend can handle comma-separated string directly based on user request.
      queryParams.messageType = params.messageType;
    }

    // Add messageDirection if it's selected
    if (params.messageDirection && params.messageDirection !== '') {
      queryParams.messageDirection = params.messageDirection;
    }

    // Convert query parameters to JSON string
    const queryParamsString = Object.keys(queryParams).length > 0 ? JSON.stringify(queryParams) : '{}';

    const response = await GraphqlService.getSandboxObject(
      myProject.code, `rawmessages/${myProject.code}/${validityValue || validity}`, queryParamsString, filters, startDate, endDate, MAX_DAYS_BETWEEN_DATES, paginationToken,
    );

    // eslint-disable-next-line no-plusplus
    if (response) {
      setPaginationTokens((prev) => {
        if (response?.pagination && response?.pagination.paginationContinuationToken && !prev.some((token) => token === response.pagination.paginationContinuationToken)) {
          return [...prev, response.pagination.paginationContinuationToken];
        }
        return prev;
      });
      const generalData = JSON.parse(response.data);
      return generalData;
    }
    return [];
  }

  async function search(myProject, filters, startDate, endDate, startTime, endTime, newPage, validityValue) {
    // Enhanced logging to debug permission issue

    // if (isLoadingDevicePermission || isFetchingDevicePermission) {
    //   return null;
    // }

    // if (!isDeviceAllowed) {
    //   openAlert('Error', 'Device does not have the required permissions.');
    //   return null;
    // }

    try {
      setSubmitting(true);
      setIsLoading(true);
      setLoading(true);
      let creationResponse = [];

      setReducedPage(newPage || 0);
      creationResponse = await searchObject(myProject, filters, calculateStartDateTimeIso(startDate, startTime), calculateEndDateTimeIso(endDate, endTime), paginationTokens[newPage] ? paginationTokens[newPage] : undefined, validityValue);
      setReducedResponse(creationResponse);
      setMoreThanMaxDaysDateError(false);

      setSubmitting(false);
      setIsLoading(false);
      setLoading(false);
      return creationResponse;
    } catch (error) {
      setIsLoading(false);
      setSubmitting(false);
      setLoading(false);
      openAlert('Error', error.message);
      return null;
    }
  }

  const onSubmit = () => {
    // Analytics event for search button
    setAnalytics({
      event: 'button_clicked',
      extraParams: {
        name: deviceSerial
          ? 'device_management-overview-raw_data-search'
          : 'device_management-raw_data-search',
      },
    });
    if (validate(selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime, MAX_DAYS_BETWEEN_DATES, setDateStartError, setDateEndError, setSelectedStartDate, setSelectedStartTime, setSelectedEndDate, setSelectedEndTime, setGreaterSmallerDateError, setMoreThanMaxDaysDateError)) {
      search(
        project, selectedFilters, selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime,
      );
    }
  };

  // WEBPAGE______________________________
  const classes = useStyles();

  useEffect(() => {
    setPaginationTokens(['']);
  }, [selectedFilters, selectedStartDate, selectedEndDate, project, params.deviceSerial, params.messageDirection]);

  const handleRadioChange = (event) => {
    const newValidity = event.target.value;
    setValidity(newValidity);
    search(
      project,
      selectedFilters,
      selectedStartDate,
      selectedEndDate,
      selectedStartTime,
      selectedEndTime,
      0,
      newValidity
    );
  };

  useEffect(() => {
    if (deviceSerial) {
      search(
        project,
        selectedFilters,
        selectedStartDate,
        selectedEndDate,
        selectedStartTime,
        selectedEndTime,
        0,
      );
    }
  }, []);

  useEffect(() => {
    if (shouldClear) {
      // Reset all necessary state variables
      setReducedResponse(null);
      setPaginationTokens(['']);
      setReducedPage(0);
      setSelectedFilters('');
      setValidity('valid');
      setSelectedStartDate(moment().add(-7, 'days'));
      setSelectedStartTime(moment().add(-7, 'days').format('HH:mm'));
      setSelectedEndDate(moment());
      setSelectedEndTime(moment().format('23:59'));
      setParams({
        deviceSerial: deviceSerial || '',
        messageType: '',
        messageDirection: ''
      });

      // Reset error states
      setDateStartError(false);
      setDateEndError(false);
      setGreaterSmallerDateError(false);
      setMoreThanMaxDaysDateError(false);
      setDeviceSerialError(false);

      // Signal completion of clearing
      if (onClearComplete) {
        onClearComplete();
      }
    }
  }, [shouldClear, onClearComplete, deviceSerial]);

  return (
    <Box spacing={0}>
      <SimpleAlert open={alertOpen} setOpen={setAlertOpen} header={alertHeader} body={alertText} />
      {!deviceSerial
        && <PageBanner title="DEVICE RAW DATA" />}
      {/*
      <FineGrainedPermissionsInfo
        open={false}
        onClose={() => { }}
        style={{ margin: 24 }}
      /> */}

      <Grid
        container
        spacing={0}
        className={classes.content}
      >
        <Grid item xs={12}>

          <FiltersWithMultiSelect
            id="DeviceRawData"
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            search={onSubmit}
            selectedStartDate={selectedStartDate}
            setSelectedStartDate={setSelectedStartDate}
            selectedStartTime={selectedStartTime}
            setSelectedStartTime={setSelectedStartTime}
            selectedEndDate={selectedEndDate}
            setSelectedEndDate={setSelectedEndDate}
            selectedEndTime={selectedEndTime}
            setSelectedEndTime={setSelectedEndTime}
            greaterSmallerDateError={greaterSmallerDateError}
            setGreaterSmallerDateError={setGreaterSmallerDateError}
            moreThanMaxDaysDateError={moreThanMaxDaysDateError}
            setMoreThanMaxDaysDateError={setMoreThanMaxDaysDateError}
            filtersVisible={false}
            linkVisible={false}
            linkURL="https://nestle.atlassian.net/wiki/spaces/DIIS/pages/107785940/IoT+Message+Types"
            deviceSerialVisible={!deviceSerial}
            deviceSerial={deviceSerial ? undefined : params.deviceSerial}
            setDeviceSerial={deviceSerial ? undefined : onChangeDeviceSerial}
            deviceSerialError={deviceSerialError}
            messageTypes={params.messageType}
            setMessageTypes={onChangeMessageTypes}
            messageDirection={params.messageDirection} // Pass messageDirection
            setMessageDirection={onChangeMessageDirection} // Pass handler
            messageTypesVisible
            maxDaysBetweenDates={MAX_DAYS_BETWEEN_DATES}
            filtersComponents={[
              {
                type: 'radio',
                label: 'Message Validity',
                handleChange: handleRadioChange,
                defaultValue: 'valid',
                values: [{
                  label: 'Valid',
                  value: 'valid',
                }, {
                  label: 'Invalid',
                  value: 'invalid',
                }],
              },
            ]}
            setDateRangePickerVisibility={setDateRangePickerVisibility}
            multiSelect={true} // Set multiSelect to true
          />

        </Grid>
      </Grid>

      {(isLoading)
        ? (<LinearProgress />)
        : (
          <Grid item xs={12}>
            <DeviceRawDataTable
              search={(newPage) => search(project, selectedFilters, selectedStartDate, selectedEndDate, selectedStartTime, selectedEndTime, newPage)}
              dataList={reducedResponse}
              filters={selectedFilters}
              loading={loading}
              dateIni={calculateStartDateTimeIso(selectedStartDate, selectedStartTime)}
              dateEnd={calculateEndDateTimeIso(selectedEndDate, selectedEndTime)}
              rangeDates={MAX_DAYS_BETWEEN_DATES}
              page={reducedPage}
              setPage={setReducedPage}
              rowsPerPage={rowsPerPageConsumption}
              paginationTokens={paginationTokens}
              object={`rawmessages/${project.code}/${validity}`}
              params={params.deviceSerial !== '' ? JSON.stringify(params) : JSON.stringify({})}
              id="DeviceRawData"
              pagination="token"
              columnInclude={['validData', 'deviceSerial', 'invalidData']}
              showDeviceSerial={deviceSerial === ''}
              validity={validity} // Pass validity state
            />
          </Grid>
        )}
    </Box>
  );
}

DeviceRawData.propTypes = {
  deviceSerial: PropTypes.string,
  shouldClear: PropTypes.bool,
  onClearComplete: PropTypes.func,
};

DeviceRawData.defaultProps = {
  deviceSerial: '',
  shouldClear: false,
  onClearComplete: null,
};
